import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Item from "./Item";
import { Layout } from "../../nq-component";

function Menu({ onClickItem, menus }) {
  const [activeItem, setActiveItem] = useState(null);
  const location = useLocation();

  // Update active item based on current pathname
  useEffect(() => {
    const currentPath = location.pathname;
    // Find matching menu route
    const findActiveRoute = (menuList) => {
      for (const menu of menuList) {
        if (Array.isArray(menu.route)) {
          const found = findActiveRoute(menu.route);
          if (found) return found;
        } else {
          const route = menu.route || "/" + menu.name;
          if (currentPath === route || (route !== "/" && currentPath.startsWith(route))) {
            return route;
          }
        }
      }
      return null;
    };
    const activeRoute = findActiveRoute(menus);
    if (activeRoute) {
      setActiveItem(activeRoute);
    }
  }, [location.pathname, menus]);

  function renderDivider(index) {
    return (
      <hr 
        key={index} 
        className="dropdown-divider" 
        style={{ 
          margin: '0.75rem 0',
          borderColor: '#e9ecef',
          opacity: 0.5
        }} 
      />
    );
  }

  return (
    <ul className="navbar-nav" style={{ listStyle: 'none', padding: 0 }}>
      {menus.map((menu, i) => {
        if (!Object.keys(menu).length) return renderDivider(i);
        const key = menu.key || menu.route || "menu-" + i;
        return (
          <Item
            key={key}
            menu={menu}
            onClick={onClickItem}
            activeItem={activeItem}
            setActiveItem={setActiveItem}
            currentPath={location.pathname}
          />
        );
      })}
    </ul>
  );
}

export default Menu;
